import React from 'react';
import Label from '../../utils/label';
import useLogin from '../hooks/useLogin';
import useOutsidOfDOMClick from '../../hooks/useOutsidOfDOMClick';
import LanguageDropDown from './languageDropdown';
import { getCookie } from '../../utils/cookie';
import { RemoveQueryString, AddQueryString, getFullUrlPath, setToKafka } from '../../utils/common';
import Config from '../../utils/config';

const MenuTabMap = new Map([
    ['tab02', 0],
    ['tab01', 1]
]);

export default function LoginV3({ popupDiv, enableLogin, enableloginButtons }) {
    const {
        loginData,
        errorMessage,
        onLogin,
        onChange,
        refreshImageHash,
        viewData,
        setRefreshingLoginCode,
        onSignUp,
        onValidationKeyDown,
        initErrorMessage
    } = useLogin(popupDiv);

    const loginV3Ref = useOutsidOfDOMClick(initErrorMessage, []);
    const allowWebskinTypes = Config.appConfig.WebSkinTypeAllow.split(',');
    const hasMars = allowWebskinTypes.includes('8') && Config.appConfig.EnableJupiterOneDomain;

    const forgotPassword = event => {
        event.preventDefault();
        popupDiv(1);
    };

    const signUp = event => {
        event.preventDefault();
        onSignUp();
    };

    const redirectToMars = (obj) => {
        setToKafka(1, 3, "AthenaSite_Behavior");

        let quertyString = window.location.search.replace('?', '');
        const tab = getCookie(setCurrMainTab);
        quertyString = RemoveQueryString("webskintype", quertyString);
        quertyString = AddQueryString('webskintype=8', quertyString);
        quertyString = RemoveQueryString("act", quertyString);
        quertyString = AddQueryString(`act=${obj.sportId}`, quertyString);
        quertyString = RemoveQueryString("targetmenutab", quertyString);
        quertyString = AddQueryString(`targetmenutab=${MenuTabMap.get(tab.toLowerCase())}`, quertyString);

        let requestUrlString = getFullUrlPath(`NewIndex?${quertyString}`);
        window.location.href = requestUrlString;
    }

    return (
        <div ref={loginV3Ref} className="member-info facelift" data-tag="tagLoginFaceliftType2">
            {hasMars && (
                <div class="new-version__btn" onClick={() => redirectToMars({ key: '8', sportId: 1 })}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" fill="none" viewBox="0 0 31 31">
                        <g clip-path="url(#new-versiona)">
                            <path fill="#C95353" fill-rule="evenodd" d="M16.372 19.576a.24.24 0 0 1 .24.24v2.757a.24.24 0 0 1-.24.24h-3.521a.24.24 0 0 1-.24-.24v-2.758a.24.24 0 0 1 .24-.24h3.521Z" clip-rule="evenodd" />
                            <path fill="#E68080" fill-rule="evenodd" d="M25.225 19.816a.24.24 0 0 1-.24.24H5.555a1.55 1.55 0 0 1-1.098-.458A1.55 1.55 0 0 1 4 18.5V7.555c0-.428.175-.817.457-1.098A1.55 1.55 0 0 1 5.555 6H23.67c.427 0 .817.175 1.098.457.282.282.457.67.457 1.098v12.26Z" clip-rule="evenodd" />
                            <path fill="#F8F8F8" d="M24.745 19.576V7.555c0-.296-.121-.565-.316-.76a1.073 1.073 0 0 0-.76-.316H5.554c-.296 0-.565.121-.76.316a1.073 1.073 0 0 0-.315.76V18.5c0 .296.12.564.316.76.194.195.463.316.76.316h19.19Z" />
                            <path fill="#E68080" fill-rule="evenodd" d="M25.225 19.816a.24.24 0 0 1-.24.24H5.555a1.55 1.55 0 0 1-1.098-.458A1.55 1.55 0 0 1 4 18.5v-2.02h21.225v3.337Zm-14.028 2.518h6.83a.83.83 0 0 1 .833.833.83.83 0 0 1-.833.833h-6.83a.831.831 0 1 1 0-1.666Z" clip-rule="evenodd" />
                            <path fill="#fff" d="M12.008 18.043h5.21a.225.225 0 0 1 0 .448h-5.21a.224.224 0 1 1 0-.448Z" />
                            <path fill="#C6A692" d="M7.804 7.496h-2.19a.48.48 0 0 0-.481.48v7.28a.48.48 0 0 0 .48.481h2.191a.48.48 0 0 0 .481-.48v-7.28a.48.48 0 0 0-.48-.48Z" />
                            <path fill="#fff" d="M23.61 7.496h-2.315a.48.48 0 0 0-.48.48v1.017c0 .266.215.48.48.48h2.316a.48.48 0 0 0 .48-.48V7.977a.48.48 0 0 0-.48-.48Z" />
                            <path fill="#C6A692" d="M23.56 10h-2.12c-.243 0-.44.265-.44.592V15c0 .327.197.592.44.592h2.12c.243 0 .44-.265.44-.592v-4.408c0-.327-.197-.592-.44-.592Zm-3.688-2.504H9.325a.48.48 0 0 0-.481.48v7.28a.48.48 0 0 0 .48.481h10.548a.48.48 0 0 0 .48-.48v-7.28a.48.48 0 0 0-.48-.48Z" />
                        </g>
                        <g filter="url(#new-versionb)">
                            <path fill="#FFE015" d="M20.02 22.727 19 23l1.02.273a3.836 3.836 0 0 1 2.707 2.707L23 27l.273-1.02a3.836 3.836 0 0 1 2.707-2.707L27 23l-1.02-.273a3.836 3.836 0 0 1-2.707-2.707L23 19l-.273 1.02a3.836 3.836 0 0 1-2.707 2.707Z" />
                        </g>
                        <path fill="#FFE015" d="M3.275 20.659 2 21l1.275.341a4.795 4.795 0 0 1 3.384 3.384L7 26l.341-1.275a4.795 4.795 0 0 1 3.384-3.384L12 21l-1.275-.341a4.795 4.795 0 0 1-3.384-3.384L7 16l-.341 1.275a4.795 4.795 0 0 1-3.384 3.384Z" />
                        <g filter="url(#new-versionc)">
                            <path fill="#FFD415" d="m18.406 5.855-1.3.348 1.3.349a4.888 4.888 0 0 1 3.45 3.45l.347 1.299.349-1.3a4.888 4.888 0 0 1 3.45-3.45l1.299-.348-1.3-.348a4.888 4.888 0 0 1-3.45-3.45l-.348-1.299-.348 1.3a4.888 4.888 0 0 1-3.45 3.45Z" />
                        </g>
                        <defs>
                            <filter id="new-versionb" width="16" height="16" x="15" y="19" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse">
                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                                <feOffset dy="4" />
                                <feGaussianBlur stdDeviation="2" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2764_47167" />
                                <feBlend in="SourceGraphic" in2="effect1_dropShadow_2764_47167" result="shape" />
                            </filter>
                            <filter id="new-versionc" width="10.195" height="11.195" x="17.105" y="1.106" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse">
                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                                <feOffset dy="1" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                                <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2764_47167" />
                                <feBlend in="SourceGraphic" in2="effect1_dropShadow_2764_47167" result="shape" />
                            </filter>
                            <clipPath id="new-versiona">
                                <path fill="#fff" d="M4 6h22.095v18H4z" />
                            </clipPath>
                        </defs>
                    </svg>
                    <div class="new-version__text">
                        {Label.lbl_Ju_NewViewSwitch}
                    </div>
                </div>
            )}
            <LanguageDropDown />
            {enableloginButtons && (
                <div className="login">
                    <div className="btn btn-primary" title={Label.lbl_login} data-tag="tabBtn" onClick={() => popupDiv(2)}>
                        {Label.lbl_login}
                    </div>
                    <div className="btn btn-withIcon btn-secondary" title={Label.lbl_Signup} data-tag="tabBtnWithIcon" onClick={onSignUp}>
                        <i className="icon-account" />
                        {Label.lbl_Signup}
                    </div>
                </div>
            )}
            {enableLogin && (
                <React.Fragment>
                    <div className="login">
                        <form>
                            <div className={`login__item ${errorMessage.username ? 'error' : ''}`}>
                                <input
                                    id="username"
                                    type="text"
                                    autoComplete="off"
                                    placeholder={Label.lbl_username}
                                    value={loginData.username}
                                    onChange={onChange}
                                />
                                <label>
                                    <input
                                        id="rememberMe"
                                        type="checkbox"
                                        checked={loginData.rememberMe}
                                        onChange={onChange}
                                        tabIndex={-1}
                                    />
                                    {Label.lbl_RememberMe}
                                </label>
                                {errorMessage.username && <div className={`hint-absolute${errorMessage.username && errorMessage.password ? '-large' : ''}`}>{errorMessage.username}</div>}
                            </div>
                            <div className={`login__item ${errorMessage.password ? 'error' : ''}`}>
                                <input
                                    id="password"
                                    type="password"
                                    autoComplete="off"
                                    placeholder={Label.lbl_Passwd}
                                    value={loginData.password}
                                    onChange={onChange}
                                />
                                {/* if errorMessage.password === ' ' show error frame, but not show error message */}
                                {errorMessage.password.trim() && <div className="hint-absolute">{errorMessage.password}</div>}
                            </div>
                            <div className={`login__validation ${errorMessage.validation ? 'error' : ''}`}>
                                <input
                                    id="validation"
                                    type="text"
                                    placeholder={Label.lbl_code}
                                    value={loginData.validation}
                                    onChange={onChange}
                                    onKeyDown={onValidationKeyDown}
                                />
                                <img src={getFullUrlPath(`login_code.aspx?${loginData.imageHash}`)} className="garyy" onLoad={() => setRefreshingLoginCode(false)} />
                                <div className={`btn btn-small btn-info ${viewData.refreshingLoginCode ? 'spin' : ''}`} data-tag="tabSmallBtnIcon" onClick={refreshImageHash}>
                                    <i className="icon-refresh" />
                                </div>
                                {errorMessage.validation && <div className="hint-absolute">{errorMessage.validation}</div>}
                            </div>
                            <div
                                className={['btn btn-secondary', viewData.logining ? 'disable' : ''].join(' ')}
                                title={Label.lbl_login}
                                data-tag="tabBtn"
                                onClick={onLogin}
                            >
                                {Label.lbl_login}
                            </div>
                        </form>
                    </div>
                    <div className="forgot">
                        <ul>
                            <li>
                                <a href="#" onClick={forgotPassword}>{Label.lbl_Forget}</a>
                            </li>
                            <li className="icon-account">
                                <a href="#" onClick={signUp}>{Label.lbl_Signup}</a>
                            </li>
                        </ul>
                    </div>
                </React.Fragment>
            )}
        </div>
    );
}
